<template>
  <div class="mt-4">
    <h4>{{ $t("message.tableDetails") }}</h4>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label v-if="!isRolldStore()" class="required" for="TableNumber">{{
          $t("message.tableNumber")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.TableNumber ? 'd-none' : 'required rolld'"
          for="tableNumber"
        ></label>
        <input
          v-if="!isAmadeous"
          v-validate="'required'"
          id="TableNumber"
          :placeholder="isRolldStore() ? $t('message.tableNumber') : ''"
          v-model="editModel.TableNumber"
          name="tableNumber"
          type="text"
          class="form-control"
        />
        <input
          v-else
          readonly="readonly"
          v-validate="'required'"
          id="TableNumber"
          :placeholder="isRolldStore() ? $t('message.tableNumber') : ''"
          v-model="editModel.TableNumber"
          name="tableNumber"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("tableNumber") | inputNameLocale("tableNumber") }}
        </div>
      </div>
      <div class="form-group col-md-12" v-if="showGuestCount">
        <label class="required" for="Guest Count">{{
          $t("message.guestCount")
        }}</label>
        <input
          v-validate="{ required: true, numeric: true }"
          id="GuestCount"
          v-model="editModel.GuestCount"
          name="guestCount"
          type="number"
          class="form-control"
          min="1"
          @change="handleChange"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("guestCount") | inputNameLocale("guestCount") }}
        </div>
      </div>
      <div
        v-if="
          editModel.GuestCount && editModel.GuestCount > getGuestsPerTableMax
        "
        class="alert alert-light"
        role="alert"
      >
        Value entered is greater than {{ getGuestsPerTableMax }}
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6" v-if="showFirstNameFields">
        <label v-if="!isRolldStore()" class="required" for="Full Name">{{
          $t("message.name")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.FirstName ? 'd-none' : 'required rolld'"
          for="name"
        ></label>
        <input
          v-validate="'required'"
          minlength="2"
          id="Name"
          :placeholder="isRolldStore() ? $t('message.name') : ''"
          v-model="fullName"
          name="name"
          type="text"
          class="form-control"
          @keypress="checkKeyDownAlphaNumeric($event)"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("name") | inputNameLocale("name") }}
        </div>
      </div>
      <!--      <div class="form-group col-md-6" v-if="showLastNameFields">-->
      <!--        <label v-if="!isRolldStore()" class="required" for="Last Name">{{-->
      <!--          $t("message.lastName")-->
      <!--        }}</label>-->
      <!--        <label-->
      <!--          v-if="isRolldStore()"-->
      <!--          :class="editModel.LastName ? 'd-none' : 'required rolld'"-->
      <!--          for="lastName"-->
      <!--        ></label>-->
      <!--        <input-->
      <!--          v-validate="'required'"-->
      <!--          minlength="2"-->
      <!--          id="LastName"-->
      <!--          :placeholder="isRolldStore() ? $t('message.lastName') : ''"-->
      <!--          v-model="editModel.LastName"-->
      <!--          name="lastName"-->
      <!--          type="text"-->
      <!--          class="form-control"-->
      <!--        />-->
      <!--        <div class="invalid-feedback">-->
      <!--          {{ OOErrors.first("lastName") | inputNameLocale("lastName") }}-->
      <!--        </div>-->
      <!--      </div>-->
    </div>

    <div
      class="form-row"
      v-if="(!user && viewConfig.LogIn) || !viewConfig.LogIn"
    >
      <div class="form-group col-md-12" v-if="shouldCollectEmail">
        <label v-if="!isRolldStore()" class="required" for="EmailAddress">{{
          $t("message.emailAddress")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.Email ? 'd-none' : 'required rolld'"
          for="emailAddress"
        ></label>
        <input
          v-validate="'required|email'"
          @change="checkEmailExistance(editModel.Email)"
          @load="checkEmailExistance(editModel.Email)"
          @blur="checkEmailExistance(editModel.Email)"
          @keydown="userIsExist = false"
          id="EmailAddress"
          :placeholder="isRolldStore() ? $t('message.emailAddress') : ''"
          v-model="editModel.Email"
          name="emailAddress"
          type="email"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("emailAddress") | inputNameLocale("emailAddress") }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12" v-if="ShowDineInPhoneNumber">
        <label :class="{ required: isDineInSMSEnabled }" for="PhoneNumber">{{
          $t("message.mobile")
        }}</label>
        <input
          v-validate="phoneValidationExpression"
          id="PhoneNumber"
          v-model="editModel.PhoneNumber"
          name="phoneNumber"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}
        </div>
      </div>
    </div>
    <div class="form-row" v-if="selectedCompany.DineInField">
      <div class="form-group col-md-12">
        <label for="DineInField">{{ selectedCompany.DineInField }}</label>
        <input
          id="DineInField"
          v-model="editModel.DineInField"
          name="DineInField"
          type="text"
          class="form-control"
        />
      </div>
    </div>

    <!-- <div class="form-row" v-show="createNewAccount">
      <div class="form-group col-md-12">
        <div class="form-group ">
          <label for="password"
          >{{ $t("message.password") }}
            <span class="required-logo">*</span>
          </label>
          <input
              id="passwordId"
              v-model="editModel.Password"
              type="password"
              name="password"
              v-validate="'required|min:6'"
              class="form-control"
              ref="password"
              autocomplete="new-password"
          />
          <div class="invalid-feedback">
            {{ OOErrors.first("password") | inputNameLocale("password") }}
          </div>
        </div>
        <div class="form-group">
          <label for="Confirm Password">
            {{ $t("message.confirmPassword") }}
            <span class="required-logo">*</span>
          </label>
          <input
              id="ConfirmPasswordId"
              v-model="editModel.ConfirmPassword"
              type="password"
              name="confirmPassword"
              v-validate="'required|confirmed:password'"
              class="form-control"
          />
          <div class="invalid-feedback">
            {{
              OOErrors.first("confirmPassword")
                  | inputNameLocale("confirmPassword")
            }}
          </div>
        </div>

        <div v-if="!isRolldStore()" class="form-group">
          <label for="birth Date"
          >{{ $t("message.birthDate") }}
            <span class="required-logo">*</span>
          </label>
          <date-pick
              id="BirthDate"
              name="birthDate"
              v-model="editModel.BirthDate"
              :format="'DD/MM/YYYY'"
              :inputAttributes="{
                placeholder: 'DD/MM/YYYY',
                class: ['form-control', bdstatus],
              }"
              @input="isValidDate($event)"
              :parseDate="parseDate"
          ></date-pick>
          <span
              v-if="birthDatestatus != 0"
              class="invalid-feedback"
              style="display: block;"
          >{{
              birthDatestatus == 1
                  ? $t("message.birthDateRequire")
                  : "The Date of Birth should be DD/MM/YYYY format"
            }}</span
          >
          <div class="invalid-feedback">
            {{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}
          </div>
        </div>

      </div> -->

    <!--      <div class="form-group col-md-6">-->
    <!--        <label v-if="!isRolldStore()" class="required" for="phoneNumber">{{-->
    <!--          $t("message.phoneNumber")-->
    <!--        }}</label>-->
    <!--        <label-->
    <!--          v-if="isRolldStore()"-->
    <!--          :class="editModel.Phone ? 'd-none' : 'required rolld'"-->
    <!--          for="phoneNumber"-->
    <!--        ></label>-->
    <!--        <input-->
    <!--          v-validate="{-->
    <!--            required: true,-->
    <!--            min: 8,-->
    <!--            regex: this.getRegex(),-->
    <!--          }"-->
    <!--          id="phoneNumber"-->
    <!--          :placeholder="isRolldStore() ? $t('message.phoneNumber') : ''"-->
    <!--          v-model="editModel.Phone"-->
    <!--          name="phoneNumber"-->
    <!--          :disabled="isMobileReadonly"-->
    <!--          type="text"-->
    <!--          class="form-control"-->
    <!--        />-->
    <!--        <div class="invalid-feedback">-->
    <!--          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!-- </div> -->

    <!--   display component when show other user fields are enabled  -->
    <div
      v-if="
        showPayment &&
        !user &&
        viewConfig.LogIn &&
        showFirstNameFields &&
        shouldCollectEmail
      "
      class="form-row"
    >
      <div class="form-group col-md-12">
        <div class="custom-control custom-checkbox col-md-12 ml-12">
          <input
            id="newAccount"
            type="checkbox"
            name="customCheckbox"
            :checked="createNewAccount"
            @change="check"
            class="custom-control-input"
            @input="(val) => $emit('save-user', val.target.checked)"
          />
          <label
            class="custom-control-label join-membership-text"
            for="newAccount"
          >
            {{ $t("message.joinMembershipToEarnStamps") }}
            <!--            <small class="light-text d-block">-->
            <!--              {{ $t("message.placingOrderAsGuest")}}-->
            <!--            </small>-->
          </label>
        </div>
      </div>
      <div class="form-group col-md-12" v-if="this.isBranded()">
        <div v-if="createNewAccount && userIsExist">
          {{ $t("message.alreadyAccountForEmail") }}
          <router-link
            class="text-primary"
            :to="{
              name: 'login',
              params: { storeid: $parent.storeid, forgift: forGift },
            }"
            >{{ $t("message.login") }}</router-link
          >&nbsp;here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../../../sharedscripts/shop/Checkout/Checkout.js";
import { mapActions, mapGetters } from "vuex";

import { userIsExist } from "../../../../api/services/userService";
import "vue-date-pick/dist/vueDatePick.css";
// import DatePick from "vue-date-pick";
export default {
  name: "EatIn",
  // components : {
  //   DatePick
  // },
  props: {
    editModel: {
      type: Object,
      default: () => {},
    },
    isPayByCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userIsExist: false,
      createNewAccount: false,
      birthDatestatus: 0,
      birthDate: "",
    };
  },
  computed: {
    ...mapGetters([
      "viewConfig",
      "getTotalPrice",
      "user",
      "selectedCompany",
      "currentStoreDoc",
      "getCount",
      "getGuestsPerTableMax",
      "getGuestsPerTableMin",
      "showGuestCount",
    ]),
    isAmadeous() {
      if (this.$route.query.table || localStorage.getItem("table")) {
        return true;
      }
      return false;
    },
    showPayment() {
      return this.$parent.showPayment;
    },
    showFirstNameFields() {
      return (
        !!this.isDineInSMSEnabled ||
        !this.isAmadeous ||
        (this.isAmadeous &&
          this.selectedCompany.ViewComponentConfigs.ShowDineInFirstLastName)
      );
    },
    showLastNameFields() {
      return (
        !this.isAmadeous ||
        (this.isAmadeous &&
          this.selectedCompany.ViewComponentConfigs.ShowDineInFirstLastName)
      );
    },
    isDineInSMSEnabled() {
      return this.selectedCompany.ViewComponentConfigs.DineInSMSconfirmation;
    },
    ShowDineInPhoneNumber() {
      return (
        !!this.isDineInSMSEnabled ||
        !this.isAmadeous ||
        (this.isAmadeous &&
          this.selectedCompany.ViewComponentConfigs.ShowDineInPhoneNumber)
      );
    },
    phoneValidationExpression() {
      let phoneValidations = {};
      if (this.ShowDineInPhoneNumber) {
        phoneValidations = {
          ...phoneValidations,
          min: 8,
          regex: this.getRegex(),
          max: this.getMax(),
        };
      }
      if (this.isDineInSMSEnabled) {
        phoneValidations = { ...phoneValidations, required: true };
      }
      return phoneValidations;
    },
    shouldCollectEmail() {
      if (this.$route.query.table) {
        return this.currentStoreDoc.PayLaterDisplayEmailEnabled;
      }
      if (this.isPayByCard) {
        return true;
      }
      return this.currentStoreDoc.PayLaterDisplayEmailEnabled;
    },

    fullName: {
      get() {
        if (!this.editModel.LastName.length) {
          return this.editModel.FirstName;
        }
        return this.editModel.FirstName + " " + this.editModel.LastName;
      },
      set(val) {
        if (!val) return;
        const newValue = val.trim();
        let names = newValue.split(" ");
        this.editModel.LastName = "";
        if (names.length === 2) {
          this.editModel.FirstName = names[0];
          this.editModel.LastName = names[1];
          return;
        }
        if (names.length > 2) {
          this.editModel.FirstName = names[0];
          this.editModel.LastName = names.slice(1, names.length + 1).join(" ");
          return;
        }
        this.editModel.FirstName = names[0];
      },
    },
    bdstatus() {
      return this.birthDatestatus != 0 ? "invaliddatetime" : "";
    },
  },
  mounted() {
    this.checkEmailExistance(this.editModel.Email);
    const tableNumber =
      this.$route.query.table || localStorage.getItem("table");
    if (tableNumber && !this.editModel.TableNumber) {
      this.editModel.TableNumber = tableNumber;
    }
    if (this.getCount && !this.editModel.GuestCount) {
      this.editModel.GuestCount = this.getCount;
    }
  },
  methods: {
    ...shared.methods,
    ...mapActions(["setPeople"]),
    syncFirstName(firstName) {
      if (this.$parent.syncFirstName) this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    checkEmailExistance(email) {
      userIsExist(email)
        .then((result) => {
          if (result.length > 0) {
            this.$parent.setUserIsExist(true);
            this.userIsExist = true;
          } else {
            this.$parent.setUserIsExist(false);
            this.userIsExist = false;
          }
        })
        .catch(() => {
          this.$parent.setUserIsExist(false);
          this.userIsExist = false;
        });
    },
    check: function (event) {
      this.createNewAccount = event.target.checked;
    },
    setRegisterNewUserState(state) {
      this.createNewAccount = state;
    },
    getMax() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10 : 15;
    },
    getRegex() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? /^[04]\d{8}/ : /\d/;
    },
    isValidDate(s) {
      if (s && s != "") {
        let bits = s.split("/");
        let d = new Date(bits[2], bits[1] - 1, bits[0]);
        let valid =
          d.getFullYear() == bits[2] &&
          d.getMonth() + 1 == bits[1] &&
          bits[2].length == 4;
        if (valid) {
          this.birthDatestatus = 0;
          return true;
        } else {
          this.birthDatestatus = 2;
          return false;
        }
      } else {
        this.birthDatestatus = 1;
        return false;
      }
    },
    parseDate(dateString) {
      let date = dateString.split("/");
      if (
        date[0] &&
        date[0].length > 0 &&
        date[1] &&
        date[1].length > 0 &&
        date[2] &&
        date[2].length == 4
      ) {
        return new Date(date[2], date[1] - 1, date[0]);
      } else {
        return undefined;
      }
    },
    handleChange() {
      if (!this.OOErrors.first("guestCount"))
        this.setPeople(this.editModel.GuestCount);
    },
    checkKeyDownAlphaNumeric(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z ]+(\s[a-zA-Z]+)?$/.test(char)) return true;
      else e.preventDefault();
    },
  },
};
</script>
